import {simpleYmd} from "./simple_ymd.js";

export function sameDay(previous) {
  if (!previous) {
    return false;
  }
  return simpleYmd() === previous;
}
